import { useMemo } from "react";
import { useQuery } from "react-query";

import { useReactAppState } from "../../shared/containers/utils";
import { d3ClubsBySportecIdsAPI } from "../../shared/api/variables";
import { fetchClient } from "../../shared/api/fetching";

function useForgeClubs({ clubs }) {
    const { apiList } = useReactAppState();
    const clubSportecIds = useMemo(() => clubs?.map(club => club.club_id), [clubs]);

    const d3ClubsEndpoint = d3ClubsBySportecIdsAPI({ clubSportecIds });

    return useQuery({
        queryKey: ["d3-clubs", clubSportecIds],
        queryFn: () => fetchClient({ endpoint: d3ClubsEndpoint, apiURL: apiList.d3SportsAPI }),
        enabled: clubSportecIds?.length > 0,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchIntervalInBackground: false,
        refetchIntervalInBackground: false,
    });
}

export default useForgeClubs;

